import { Injectable, isDevMode } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Product, BasketProduct, Delivery, User, ScheduleDelivery, ListUserAddress, DeliveryReservation, BasketPrice, ShoppingList, PaymentData, ScheduleDeliveries, InfoLog, Batch, Category, Text } from '../_models';
import { Observable, of, BehaviorSubject, iif, throwError, forkJoin } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from './authentication.service';
import { tap, map, catchError, finalize, mergeMap, delay, flatMap, retryWhen, concatMap, switchMap, concat, max, share } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { CatalogService } from './catalog.service';
import { Order } from '../_models/order';
import { PlusToast } from '../plus.toast';

@Injectable({ providedIn: 'root' })
export class BasketService {
    //20250602 axa inici
    //user: User;
    //20250602 axa final
    basketId : number;

    adding : Product;
    removing : Product;

    refreshing : boolean;

    private basketPriceSubject : BehaviorSubject<BasketPrice>;
    private productsSubject : BehaviorSubject<BasketProduct[]>;
    //private deliveryStatusSubject : BehaviorSubject<string>;
    private deliverySubject : BehaviorSubject<Delivery>;
    private inCheckOutSubject : BehaviorSubject<boolean>;

    public products : Observable<BasketProduct[]>;
    public basketPrice : Observable<BasketPrice>;
    //public deliveryStatus : Observable<string>;
    public delivery : Observable<Delivery>;
    public inCheckOut : Observable<boolean>;
    

    public cachedSchedules : Observable<ScheduleDeliveries> = null;

    constructor(
        private http: HttpClient,
        private toastr: ToastrService,
        private auth : AuthenticationService,
        private translate : TranslateService,
        private catalog : CatalogService,
    ) {
        this.adding = null;
        this.removing = null;
        this.refreshing = false;

        this.basketPriceSubject = new BehaviorSubject<BasketPrice>(null)
        this.basketPrice = this.basketPriceSubject.asObservable();

        this.productsSubject = new BehaviorSubject<BasketProduct[]>([]);
        this.products = this.productsSubject.asObservable();

        //this.deliveryStatusSubject = new BehaviorSubject<string>(null);
        //this.deliveryStatus = this.deliveryStatusSubject.asObservable();

        
        this.deliverySubject = new BehaviorSubject<Delivery>(null);
        this.delivery = this.deliverySubject.asObservable();

        this.inCheckOutSubject = new BehaviorSubject<boolean>(false);
        this.inCheckOut = this.inCheckOutSubject.asObservable();

      //20250602 axa inici

       //this.auth.currentUser.subscribe( user => {
       //    this.user = user;
       //    if (this.user){
       //        this.get().subscribe();
       //        this.getDelivery().subscribe();
       //    }
       //});

      this.auth.currentUser.subscribe(user => {
          if (this.auth.currentUserValue) {
            this.get().subscribe();
            this.getDelivery().subscribe();
          }
        });
      //20250602 axa final
        
     }

    public get isEmpty () : boolean {
        return this.productsSubject.value.length == 0;
    }

    public setCheckOut( value : boolean){
        this.inCheckOutSubject.next(value);
    }

    public inBasket(product : Product) : BasketProduct {
        let bProduct: BasketProduct = null; 
        bProduct =  this.productsSubject.value.find( bp => bp.item_id  === product.item_id && ! bp.gift);
        return bProduct;
    }

    public inBasketAsGift(product : Product) : BasketProduct {
        let bProduct: BasketProduct = null; 
        bProduct =  this.productsSubject.value.find( bp => bp.item_id  === product.item_id &&  bp.gift);
        return bProduct;
    }

    public findProduct(product: BasketProduct){
        return this.productsSubject.value.find( bProduct => {
            let found : boolean = false;
            let contains : boolean = true;
            found = product.item_id  === bProduct.item_id;
            if (found){
                product.selected_options.forEach(so => {
                    contains  = contains &&  bProduct.selected_options.find (so2 => {
                        return so && so2.option_id === so.option_id;
                    }) != null;
                });
            }           
            return found && contains;
        });
    }

    public more(product : Product) {
        let bProduct : BasketProduct = new BasketProduct();
        bProduct.product = product;
        bProduct.item_id = product.item_id;
        bProduct.flag_action = true;
        bProduct.qty_milis = 0;
        return this.add(bProduct);
    }

    public less(product : Product) {
        let bProduct : BasketProduct = new BasketProduct();
        bProduct.product = product;
        bProduct.item_id = product.item_id;
        bProduct.flag_action = false;
        bProduct.qty_milis = 0;
        return this.add(bProduct);
    }

    public setQuantity(product : Product, quantity : number) {
        if (quantity > 0){
            let bProduct : BasketProduct = new BasketProduct();
            bProduct.product = product;
            bProduct.item_id = product.item_id;
            bProduct.flag_action = false;
            bProduct.qty_milis = Math.min(quantity,999) * 1000;
            return this.add(bProduct);
        } else {
         this.toastr.error(this.translate.instant('BASKET.ADD_QUANTITY'));
         return of(null);
        }
    }

    public moreFormat(bProduct : BasketProduct) {
        bProduct.quantity += bProduct.selected_serviceFormatOption.interval;
        return this.add(bProduct);
    }

    public lessFormat(bProduct : BasketProduct) {
        if (bProduct.quantity >= bProduct.selected_serviceFormatOption.min){
            bProduct.quantity -= bProduct.selected_serviceFormatOption.interval ;
        }
        else {
            bProduct.quantity = bProduct.selected_serviceFormatOption.min;
        }
        return this.add(bProduct);
    }


    //////////////////////////////////////////////
    //      SUPSA BASKET                      //
    //////////////////////////////////////////////

    // internal
    public get () {
      this.refreshing = true;
        //20250602 axa inici
        //return this.http.get<any>(`${environment.API_ENDPOINT}basket/${this.user.id_user}/query`).pipe(
      return this.http.get<any>(`${environment.API_ENDPOINT}basket/${this.auth.currentUserValue.id_user}/query`).pipe(
        //20250602 axa final

        map(basketId => {
          this.basketId = basketId;
          this.getProducts().subscribe(r => {
            this.total().subscribe(rr => {
              this.refreshing = false;
            });

          });
         // console.log("get: " + this.basketId);
        }, error => {
         // console.log("get-error: " + error.statusText + '->' + error.message);
          this.toastr.warning(error.statusText + '->' + error.message);
          this.basketId = 0;
          this.refreshing = false;
        }),

      );
    }
   
    public getPSD2 () {
      this.refreshing = true;
      //20250602 axa inici
      //return this.http.get<any>(`${environment.API_ENDPOINT}basket/${this.user.id_user}/query`).pipe(
      return this.http.get<any>(`${environment.API_ENDPOINT}basket/${this.auth.currentUserValue.id_user}/query`).pipe(
      //20250602 axa final
            map ( basketId =>{
                this.basketId = basketId;
                this.getProducts().subscribe(r =>{                   
                    this.total().subscribe(rr =>{
                        this.totalPSD2().subscribe(rrr => {
                            this.refreshing = false;
                        });  
                    });
                });
             // console.log("getpsd2: " + this.basketId);

            }, error =>{
                this.toastr.warning(error.statusText + '->' + error.message);
                this.basketId = 0;
                this.refreshing = false; 
            }),
        );
    }

    // insternal
    private getProducts()  : Observable<BasketProduct[]>{
        // https://tweb3.plusfresc.cat/api/basket/{id_user}/{id_basket}/details
      //20250602 axa inici
      // return this.http.get<BasketProduct[]>(`${environment.API_ENDPOINT}basket/${this.user.id_user}/${this.basketId}/details`).pipe
      return this.http.get<BasketProduct[]>(`${environment.API_ENDPOINT}basket/${this.auth.currentUserValue.id_user}/${this.basketId}/details`).pipe(
        //20250602 axa final
        delay(environment.FAKE_DELAY),
            retryWhen(errors => {
                return errors.pipe(
                    // Use concat map to keep the errors in order and make sure they aren't executed in parallel
                    concatMap( (e, i) => 
                    // Executes a conditional Observable depending on the result of the first argument
                    iif(
                      () => i > environment.MAX_RETRY_COUNT,
                      // If the condition is true we throw the error (the last error)
                      throwError(e),
                      // Otherwise we pipe this back into our stream and delay the retry
                      of(e).pipe(delay(environment.RETRY_DELAY)) 
                    )
                  )
                );
            }),
            map( result => {
                let products : BasketProduct[] = [];
                products = result.map(item => new BasketProduct(item));
                this.productsSubject.next(products);
                return products;
            }),
            catchError(err => {
                this.toastr.warning(err.statusText + '->' + err.message);
                this.resetStatus();
                return of([]);
            }),
        finalize(() => {
          //console.log("getProducts: " + this.basketId);
}),
        );
    }

    public empty (){
        // https://tweb3.plusfresc.cat/api/basket/{id_user}/{id_basket}/clear
      this.refreshing = true;

        //20250602 axa inici
      //return this.http.delete<any>(`${environment.API_ENDPOINT}basket/${this.user.id_user}/${this.basketId}/clear`).pipe(

        return this.http.delete<any>(`${environment.API_ENDPOINT}basket/${this.auth.currentUserValue.id_user}/${this.basketId}/clear`).pipe(
          //20250602 axa final

        tap(result => {
                this.getProducts().subscribe( products => {
                    if (products.length == 0){
                        this.toastr.success(this.translate.instant('BASKET.EMPTY'))
                    }
                    this.total().subscribe( rr =>{
                        this.resetStatus();
                    });
                });               
            }, error =>{
                if (isDevMode){
                    this.toastr.warning(error.statusText + '->' + error.message);
                }
                this.resetStatus();
            }),
        );
    }

    add ( bProduct : BasketProduct  )  {
        // https://tweb3.plusfresc.cat/api/basket/{id_user}/{id_basket}/add
        this.adding = bProduct.product;
        this.refreshing = true;
      let p: BasketProduct = null;

      //console.log("add: " + this.basketId);
        //20250602 axa inici
        //return this.http.post<InfoLog[]>(`${environment.API_ENDPOINT}basket/${this.user.id_user}/${this.basketId}/add`, bProduct).pipe(
        return this.http.post<InfoLog[]>(`${environment.API_ENDPOINT}basket/${this.auth.currentUserValue.id_user}/${this.basketId}/add`, bProduct).pipe(
        //20250602 axa inici
          map(result => {
                let infoLogs : InfoLog[] = result.map(item => new InfoLog(item));

                this.getProducts().subscribe( products => {
                    p  = this.findProduct(bProduct);
                    if (p){
                        this.toastr.success( this.translate.instant('BASKET.ADDED', {
                            name : bProduct.product.getText(this.translate.currentLang) , 
                            mainFormat :  p.getMainFormatText(this.translate.currentLang, this.translate.instant('UNITS')),
                            optionFormat :  p.getOptionFormatText(this.translate.currentLang, this.translate.instant('BASKET.FORMAT')),
                            quantity : p.quantity
                        }), this.catalog.url_base_img + bProduct.product.image_url);
                    } else {
                        this.toastr.success(this.translate.instant('BASKET.REMOVED', { 
                            name : bProduct.product.getText(this.translate.currentLang)
                        }), this.catalog.url_base_img + bProduct.product.image_url);
                    }
                   
                    this.total().subscribe( rr=>{
                        this.resetStatus();
                    });

                    infoLogs.forEach( (infoLog : InfoLog) =>{
                        this.toastr.show( this.translate.instant('BASKET.INFOLOG', {
                            quantity : infoLog.getQuantity() , 
                            title :  infoLog.getTitle(this.translate.currentLang),
                            description :  infoLog.getDescription(this.translate.currentLang)
                        }), this.catalog.url_base_img + infoLog.icon); // {toastClass:'toastPlus toastPlus-blue'}

                    });
                });

            }, error => {
                if (isDevMode){
                    this.toastr.warning(error.error);    
                }
                this.toastr.error(this.translate.instant('BASKET.ERROR', { 
                    name : bProduct.product.getText(this.translate.currentLang)
                }));
                this.resetStatus();
            }),
            catchError( error =>{
                if (isDevMode){
                    this.toastr.warning(error.error);    
                }
                this.toastr.error(this.translate.instant('BASKET.ERROR', { 
                    name : bProduct.product.getText(this.translate.currentLang)
                }));
                //20250602 axa inici
                this.getProducts().subscribe();
                //20250602 axa final

                this.resetStatus();
                return of();
            })
        );
    }
   
    remove(bProduct : BasketProduct){
        // https://tweb3.plusfresc.cat/api/basket/{id_user}/{id_basket}/entry/{id_entry}/clear
        this.removing = bProduct.product;
      this.refreshing = true;

      //console.log("remove: " + this.basketId);
      //20250602 axa inici
      //  return this.http.delete<any>(`${environment.API_ENDPOINT}basket/${this.user.id_user}/${this.basketId}/entry/${bProduct.basket_position}/clear`).pipe(
      return this.http.delete<any>(`${environment.API_ENDPOINT}basket/${this.auth.currentUserValue.id_user}/${this.basketId}/entry/${bProduct.basket_position}/clear`).pipe(
      //20250602 axa final
          tap(result => {
                this.getProducts().subscribe( products => {
                    let p  = this.findProduct(bProduct);
                    if (p){
                        this.toastr.success(this.translate.instant('BASKET.ADDED', {
                            name : bProduct.product.getText(this.translate.currentLang) , 
                            mainFormat :  p.getMainFormatText(this.translate.currentLang, this.translate.instant('UNITS')),
                            optionFormat :  p.getOptionFormatText(this.translate.currentLang, this.translate.instant('BASKET.FORMAT')),
                            quantity : p.quantity
                        }), this.catalog.url_base_img + bProduct.product.image_url);
                    } else {
                        this.toastr.success(this.translate.instant('BASKET.REMOVED', { 
                            name : bProduct.product.getText(this.translate.currentLang)
                        }), this.catalog.url_base_img + bProduct.product.image_url);
                    }
                    this.total().subscribe( rr =>{
                        this.resetStatus();
                    });
                 });
            }, error => {
                if (isDevMode){
                    this.toastr.warning(error.error);    
                }
                this.toastr.error(this.translate.instant('BASKET.ERROR', { 
                    name : bProduct.product.getText(this.translate.currentLang)
                }));
                this.resetStatus();
          }),
        //20250602 axa inici
        catchError(error => {
          if (isDevMode) {
            this.toastr.warning(error.error);
          }
          this.toastr.error(this.translate.instant('BASKET.ERROR', {
            name: bProduct.product.getText(this.translate.currentLang)
          }));
          this.getProducts().subscribe();
          this.resetStatus();
          return of();
        })
        //20250602 axa final
        );
    }

    // es canvia a public per a permetre la crida desde reserva de comanda (sol·licitat plus)
    public total() : Observable<BasketPrice> {
      // https://tweb3.plusfresc.cat/api/basket/{id_user}/{id_basket}/totals

     // console.log("total: " + this.basketId);
        //20250602 axa inici
        //return this.http.get<BasketPrice>(`${environment.API_ENDPOINT}basket/${this.user.id_user}/${this.basketId}/totals`).pipe(
         return this.http.get<BasketPrice>(`${environment.API_ENDPOINT}basket/${this.auth.currentUserValue.id_user}/${this.basketId}/totals`).pipe(
        //20250602 axa final
          tap(result => {
                this.basketPriceSubject.next(new BasketPrice(result));
            })
        );
    }

    // internal
  private totalPSD2(): Observable<BasketPrice> {

   // console.log("totalpsd2: " + this.basketId);
      //20250602 axa inici
      //  return this.http.get<BasketPrice>(`${environment.API_ENDPOINT}payment/${this.user.id_user}/${this.basketId}/psd2total`).pipe(
      return this.http.get<BasketPrice>(`${environment.API_ENDPOINT}payment/${this.auth.currentUserValue.id_user}/${this.basketId}/psd2total`).pipe(
      //20250602 axa final
          tap(result => {
                
                var bp = new BasketPrice();

                this.basketPrice.forEach ( elem =>{
                    bp.basketpricePSD2_cents = result.basketpricePSD2_cents
                    bp.basketprice_cents = result.basketprice_cents
                    bp.PSD2_cents = result.PSD2_cents
                    bp.base_cents = elem.base_cents
                    bp.total_cents = elem.total_cents
                    bp.delivery_cost_cents = elem.delivery_cost_cents
                    bp.offer_discount_cents = elem.offer_discount_cents
                    bp.plusi_points = elem.plusi_points
                    bp.savings_cents = elem.savings_cents
                    bp.voucher_discount_cents = elem.voucher_discount_cents
                    bp.tax_cents = elem.tax_cents
                    bp.weight_grams = elem.weight_grams
                    
                })
                
                this.basketPriceSubject.next(bp);
          })

        );
    }

    private resetStatus() {
        this.adding = null; 
        this.removing = null; 
      this.refreshing = false;

     // console.log("resetstatus: " + this.basketId);
    }

    // public addFromList ( list : ShoppingList  )  {
    //     this.refreshing = true;
    //     let adds : Observable<any>[] = [];

    //     list.line.forEach(line =>{
    //         let bProduct : BasketProduct = new BasketProduct();
    //         bProduct.product = line.product;
    //         bProduct.item_id = line.product.item_id;
    //         bProduct.flag_action = true;
    //         bProduct.quantity = line.quantity;
  //         adds.push(this.http.post<any>(`${environment.API_ENDPOINT}basket/${this.user.id_user}/${this.basketId}/add`, bProduct));
  //         adds.push(this.http.post<any>(`${environment.API_ENDPOINT}basket/${this.auth.currentUserValue.id_user}/${this.basketId}/add`, bProduct));

    //     });


    //     return forkJoin(adds).pipe(
    //         mergeMap( result => {
    //             return forkJoin([this.getProducts(), this.total()]);
    //         }),
    //         tap ( result =>{
    //             this.toastr.success(this.translate.instant('BASKET.LIST_ADDED'));
    //             this.resetStatus();
    //         }),
    //         catchError( error =>{
    //             if (isDevMode){
    //                 this.toastr.warning(error.error);
    //             }
    //             this.toastr.error(this.translate.instant('BASKET.LIST_ERROR'));
    //             this.resetStatus();
    //             return of();
    //         })

    //     );

    //     // return this.http.post<any>(`${environment.API_ENDPOINT}basket/${this.user.id_user}/${this.basketId}/add`, bProduct).pipe(
  //     // return this.http.post<any>(`${environment.API_ENDPOINT}basket/${this.auth.currentUserValue.id_user}/${this.basketId}/add`, bProduct).pipe(

  //     //     map ( result => {
    //     //         this.getProducts().subscribe( products => {
    //     //             let p  = this.findProduct(bProduct);
    //     //             if (p){
    //     //                 this.toastr.success( this.translate.instant('BASKET.ADDED', {
    //     //                     name : bProduct.product.getText(this.translate.currentLang) , 
    //     //                     mainFormat :  p.getMainFormatText(this.translate.currentLang, this.translate.instant('UNITS')),
    //     //                     optionFormat :  p.getOptionFormatText(this.translate.currentLang, this.translate.instant('BASKET.FORMAT')),
    //     //                     quantity : p.quantity
    //     //                 }), this.catalog.url_base_img + bProduct.product.image_url);
    //     //             } else {
    //     //                 this.toastr.success(this.translate.instant('BASKET.REMOVED', { 
    //     //                     name : bProduct.product.getText(this.translate.currentLang)
    //     //                 }), this.catalog.url_base_img + bProduct.product.image_url);
    //     //             }
    //     //             this.total().subscribe( rr=>{
    //     //                 this.resetStatus();
    //     //             });
    //     //         });               
    //     //     }, error => {
    //     //         if (isDevMode){
    //     //             this.toastr.warning(error.error);    
    //     //         }
    //     //         this.toastr.error(this.translate.instant('BASKET.ERROR', { 
    //     //             name : bProduct.product.getText(this.translate.currentLang)
    //     //         }));
    //     //         this.resetStatus();
    //     //     }),
    //     //     catchError( error =>{
    //     //         if (isDevMode){
    //     //             this.toastr.warning(error.error);    
    //     //         }
    //     //         this.toastr.error(this.translate.instant('BASKET.ERROR', { 
    //     //             name : bProduct.product.getText(this.translate.currentLang)
    //     //         }));
    //     //         this.resetStatus();
    //     //         return of();
    //     //     })
    //     // );
    

    // }

    
    //////////////////////////////////////////////
    //      SUPSA DELIVERY                      //
    //////////////////////////////////////////////

    
    public addFromList ( list : ShoppingList  )  {
        this.refreshing = true; 
      //20250602 axa final
      // return this.http.put<any>(`${environment.API_ENDPOINT}basket/${this.user.id_user}/${this.basketId}/${list.name}/addfromlist`,null).pipe(
      return this.http.put<any>(`${environment.API_ENDPOINT}basket/${this.auth.currentUserValue.id_user}/${this.basketId}/${list.name}/addfromlist`, null).pipe(
      //20250602 axa final
      concatMap(result => {
                return this.get().pipe(
                    tap (result =>{
                        this.toastr.success(this.translate.instant('BASKET.LIST_ADDED'));
                        this.resetStatus();       
                    })
                );
            }),
            catchError( error =>{
                this.toastr.error(this.translate.instant('BASKET.LIST_ERROR'));
                this.resetStatus();
                return of();
            })
        );
        
    }

    public addFromOrder(orderId : string) {
        this.refreshing = true; 
        //20250602 axa inici
        // return this.http.put<any>(`${environment.API_ENDPOINT}basket/${this.user.id_user}/${this.basketId}/${orderId}/addfromorder`,null).pipe(
        return this.http.put<any>(`${environment.API_ENDPOINT}basket/${this.auth.currentUserValue.id_user}/${this.basketId}/${orderId}/addfromorder`, null).pipe(
        //20250602 axa final
          concatMap(result => {
                return this.get().pipe(
                    tap (result =>{
                        this.toastr.success(this.translate.instant('BASKET.ORDER_ADDED'));
                        this.resetStatus();       
                    })
                );
            }),
            catchError( error =>{
                this.toastr.error(this.translate.instant('BASKET.ORDER_ERROR'));
                this.resetStatus();
                return of();
            })
        );
        

    }
    
  getDelivery() {
      //20250602 axa inici
    // return this.http.get<any>(`${environment.API_ENDPOINT}delivery/${this.user.id_user}/check`).pipe(

    //console.log("getdelivery: " + this.basketId);
      return this.http.get<any>(`${environment.API_ENDPOINT}delivery/${this.auth.currentUserValue.id_user}/check`).pipe(
      //20250602 axa final
          concatMap(result => {
                let planned: boolean = parseInt(result) ?  true : false;
            if (planned) {
              //20250602 axa inici
              //return this.http.get<Delivery>(`${environment.API_ENDPOINT}delivery/${this.user.id_user}/show`).pipe(
              return this.http.get<Delivery>(`${environment.API_ENDPOINT}delivery/${this.auth.currentUserValue.id_user}/show`).pipe(
              //20250602 axa final
                      concatMap(result => {
							this.toastr.success(this.translate.instant('PLANIFICATION.PLANNING_TIME_REMAINING', {
                                timeRemaining: result.timeDeliveryRemaining
							}));
                            this.deliverySubject.next(result);
                            return this.delivery;
                        })
                    );  
                } else {
                    this.deliverySubject.next(null);
                    return this.delivery;
                }                       
            })
        );
    }

    // getDeliveryInfo (){
    //     return this.http.get<Delivery>(`${environment.API_ENDPOINT}delivery/${this.user.id_user}/show`).pipe(
  //     return this.http.get<Delivery>(`${environment.API_ENDPOINT}delivery/${this.auth.currentUserValue.id_user}/show`).pipe(
  //         tap ( result => {
    //             this.deliverySubject.next(result);
    //         })
    //     );

    //     // DEV: 
    //     // workarround hour range in seconds
    //     // corrected at 03/04/2019. 
    //     // deixo el codi comentat per si pot ser d'utilitat
    //     /*.pipe(
    //         map (result =>{
    //             result.fromtime = result.fromtime.split(':')[0] + ':' + result.fromtime.split(':')[1];
    //             result.totime = result.totime.split(':')[0] + ':' + result.totime.split(':')[1];
    //             return result;
    //         })
    //     );
    //     */
    // }

  getDeliveryAddress() {
        //20250602 axa inici
        // return this.http.get<ListUserAddress[]>(`${environment.API_ENDPOINT}delivery/${this.user.id_user}/address`);
        return this.http.get<ListUserAddress[]>(`${environment.API_ENDPOINT}delivery/${this.auth.currentUserValue.id_user}/address`);
        //20250602 axa inici
  }
    
    getAvailableSchedule (deliveryType : number, deliveryId : number, tiporecogida: number)  {
        let observable: Observable<any>;
        
        let encuentro: boolean = false;
        let noBasket: boolean = false;

        //console.log("getavariableshedule: " + this.basketId);
        if (this.basketId == undefined) {
          noBasket = true;
         // console.log("getavariableshedule undefined: " + this.basketId);
        }
       // console.log("getavariableshedule: " + this.basketId);
          //console.log("0 getAvailableSchedule: " + deliveryType +" "+ deliveryId +" "+ tiporecogida +" "+ new Date().toISOString())

          if (this.cachedSchedules) {
              observable = this.cachedSchedules; 
            
              //console.log("1 cachedSchedules: " + new Date().toISOString())           
              this.cachedSchedules.subscribe((data: ScheduleDeliveries) => {   
                  //console.log("1 data: " + new Date().toISOString(),data)   
                
                  if( data.deliveries.find(delivery => delivery.id_tipo !== deliveryId.toString()===undefined ))
                  {
                      encuentro=true;
                  }
                
              });
             // console.log("2 encuentro: " + new Date().toISOString(), encuentro)
           
          }
          //else {
        
          if (encuentro === false && noBasket===false) {        
              //console.log("3 ENTRO API: "+new Date().toISOString())
          
              //20250602 axa inici
            //this.cachedSchedules =  this.http.get<ScheduleDelivery[]>(`${environment.API_ENDPOINT}delivery/${this.user.id_user}/${this.basketId}/${deliveryType}/${deliveryId}/${tiporecogida}/query`)
            this.cachedSchedules = this.http.get<ScheduleDelivery[]>(`${environment.API_ENDPOINT}delivery/${this.auth.currentUserValue.id_user}/${this.basketId}/${deliveryType}/${deliveryId}/${tiporecogida}/query`)
              //20250602 axa final
                .pipe(
                  map ( result => {
                      return new ScheduleDeliveries(result);
                  }),
                  share(),
                  finalize(() => this.cachedSchedules = null)
              );
              observable = this.cachedSchedules;
          }
          if (observable) {
            return observable;
          } else {
            //console.log("retorno null: " + new Date().toISOString())
            return of(null);
          }
    }

    setDelivery( reservation : DeliveryReservation){
      reservation.salesbasketid = this.basketId;
      //20250602 axa inici
       // return this.http.post<any>(`${environment.API_ENDPOINT}delivery/${this.user.id_user}/create`, reservation).pipe(
      return this.http.post<any>(`${environment.API_ENDPOINT}delivery/${this.auth.currentUserValue.id_user}/create`, reservation).pipe(
      //20250602 axa final
          concatMap(result => {
                this.toastr.success(this.translate.instant('PLANIFICATION.PLANIFIED', {
                    hourRange : reservation.transdate + ' ' + reservation.fromtime + ' - ' + reservation.totime
                }));
                
                return  this.auth.refreshAccessToken().pipe(
                    concatMap(result =>{
                        return  this.getDelivery().pipe();
                    }) 
                );
            }),
            catchError (error => {
                this.toastr.error(this.translate.instant('PLANIFICATION.PLANNING_ERROR'));
                return throwError(error);
            })
        );
    }

    setBagsOption(bags:string):Observable<any>{
       //20250602 axa inici
       // return this.http.put<any>(`${environment.API_ENDPOINT}basket/${this.user.id_user}/${this.basketId}/${bags}/nobags`,bags).pipe();
      return this.http.put<any>(`${environment.API_ENDPOINT}basket/${this.auth.currentUserValue.id_user}/${this.basketId}/${bags}/nobags`, bags).pipe();
      //20250602 axa final

        //if (bags=="1") return this.http.put<any>(`${environment.API_ENDPOINT}basket/${this.user.id_user}/${this.basketId}/${bags}/nobags`,bags).pipe();    
        //else return this.http.delete<any>(`${environment.API_ENDPOINT}basket/${this.user.id_user}/${this.basketId}/${bags}/nobags`).pipe();    
    }


    //////////////////////////////////////////////
    //      SUPSA PAYMENT                       //
    //////////////////////////////////////////////

    getPaymentData(payment_mode: number) : Observable<any>{
        // https://tweb3.plusfresc.cat/api/payment/{id_usuari}/{num_cistella}/{payment_mode}/gateway

      // save basket data localy, for return OK url.

      //20250602 axa inici
      //return this.http.get<PaymentData>(`${environment.API_ENDPOINT}payment/${this.user.id_user}/${this.basketId}/${payment_mode}/gateway`).pipe(
      return this.http.get<PaymentData>(`${environment.API_ENDPOINT}payment/${this.auth.currentUserValue.id_user}/${this.basketId}/${payment_mode}/gateway`).pipe(
      //20250602 axa final
            tap ( result =>{
                this.saveBasketDataLocally();
            })
        );


    }

    private saveBasketDataLocally(){
        localStorage.setItem('currentBasket', JSON.stringify(this.productsSubject.value));
        localStorage.setItem('currentBasketPrice', JSON.stringify(this.basketPriceSubject.value));
        localStorage.setItem('currentDelivery', JSON.stringify(this.deliverySubject.value));
    }

    public getLocalBasketProducts() : BasketProduct[] {
        let products : BasketProduct[];
        products = JSON.parse(localStorage.getItem('currentBasket'));
        products = products.map(product => {
          return new BasketProduct(product);
        });

        return products;
        

    }

    public getLocalBasketPrice() : BasketPrice {
        return new BasketPrice(JSON.parse(localStorage.getItem('currentBasketPrice')));
    }

    public getLocalDelivery() : Delivery {
        return new Delivery(JSON.parse(localStorage.getItem('currentDelivery')));
    }


    public getBatches (categoryId : string) : Observable<Batch>
    {
        // /api/basket/{user}/{basket}/{promox}/batches
      //20250602 axa inici
      //  return this.http.get<any>(`${environment.API_ENDPOINT}basket/${this.user.id_user}/${this.basketId}/${categoryId}/batches`).pipe(
        return this.http.get<any>(`${environment.API_ENDPOINT}basket/${this.auth.currentUserValue.id_user}/${this.basketId}/${categoryId}/batches`).pipe(
        //20250602 axa final 
        map(result => {
                let batch : Batch = new Batch();
                batch.batch_id = categoryId;
                batch.batch_qty = result.batches;
                batch.flag_action = false;
                return batch;
            })
        );

    }

    public addBatch ( category: Category, batch : Batch )  {
        // /api/basket/{id_usuari}/{id_cistella}/batchadd 
        this.adding = new Product();
        this.refreshing = true;
        let texts : Text[] = category.getPromoTexts(this.translate.currentLang);
        //20250602 axa inici
        //return this.http.post<InfoLog[]>(`${environment.API_ENDPOINT}basket/${this.user.id_user}/${this.basketId}/batchadd`, batch).pipe(
        return this.http.post<InfoLog[]>(`${environment.API_ENDPOINT}basket/${this.auth.currentUserValue.id_user}/${this.basketId}/batchadd`, batch).pipe(
        //20250602 axa final
        map(result => {
                let infoLogs : InfoLog[] = result.map(item => new InfoLog(item));

                this.getProducts().subscribe( products => {
                    this.toastr.success( this.translate.instant('BASKET.LOT_ADDED', {
                        name : texts[0].text,
                        quantity : batch.batch_qty
                    }), environment.BASE_IMAGE_URL + category.getPromoImage(this.translate.currentLang));
            
                    this.total().subscribe( rr=>{
                        this.resetStatus();
                    });

                    infoLogs.forEach( (infoLog : InfoLog) =>{
                        this.toastr.show( this.translate.instant('BASKET.INFOLOG', {
                            quantity : infoLog.getQuantity() , 
                            title :  infoLog.getTitle(this.translate.currentLang),
                            description :  infoLog.getDescription(this.translate.currentLang)
                        }), this.catalog.url_base_img + infoLog.icon); // {toastClass:'toastPlus toastPlus-blue'}

                    });
                });

            }, error => {
                if (isDevMode){
                    this.toastr.warning(error.error);    
                }
                this.toastr.error(this.translate.instant('BASKET.ERROR', { 
                    name : texts[0].text,
                }));
                this.resetStatus();
            }),
            catchError( error =>{
                if (isDevMode){
                    this.toastr.warning(error.error);    
                }
                this.toastr.error(this.translate.instant('BASKET.ERROR', { 
                    name : texts[0].text
                }));
                this.resetStatus();
                return of();
            })
        );
    }

    public removeBatch ( category: Category, batch : Batch )  {
        // /api/basket/{id_usuari}/{id_cistella}/batchadd 
        this.adding = new Product();
        this.refreshing = true;
        let texts : Text[] = category.getPromoTexts(this.translate.currentLang);
        //20250602 axa inici
        //return this.http.post<InfoLog[]>(`${environment.API_ENDPOINT}basket/${this.user.id_user}/${this.basketId}/batchadd`, batch).pipe(
        return this.http.post<InfoLog[]>(`${environment.API_ENDPOINT}basket/${this.auth.currentUserValue.id_user}/${this.basketId}/batchadd`, batch).pipe(
        //20250602 axa final
            map ( result => {
                let infoLogs : InfoLog[] = result.map(item => new InfoLog(item));

                this.getProducts().subscribe( products => {
                    this.toastr.success( this.translate.instant('BASKET.LOT_REMOVED', {
                        name : texts[0].text
                    }), environment.BASE_IMAGE_URL + category.getPromoImage(this.translate.currentLang));
            
                    this.total().subscribe( rr=>{
                        this.resetStatus();
                    });

                    infoLogs.forEach( (infoLog : InfoLog) =>{
                        this.toastr.show( this.translate.instant('BASKET.INFOLOG', {
                            quantity : infoLog.getQuantity() , 
                            title :  infoLog.getTitle(this.translate.currentLang),
                            description :  infoLog.getDescription(this.translate.currentLang)
                        }), this.catalog.url_base_img + infoLog.icon); // {toastClass:'toastPlus toastPlus-blue'}

                    });
                });

            }, error => {
                if (isDevMode){
                    this.toastr.warning(error.error);    
                }
                this.toastr.error(this.translate.instant('BASKET.ERROR', { 
                    name : texts[0].text,
                }));
                this.resetStatus();
            }),
            catchError( error =>{
                if (isDevMode){
                    this.toastr.warning(error.error);    
                }
                this.toastr.error(this.translate.instant('BASKET.ERROR', { 
                    name : texts[0].text
                }));
                this.resetStatus();
                return of();
            })
        );
  }

  //20250602 axa inici

  //////////////////////////////////////////////
  //      COMPRA AXA                          //
  //////////////////////////////////////////////



  public getAvailableScheduleAxa(temp_id: string, deliveryType: number, deliveryId: string, tiporecogida: number) {
    let reservation: DeliveryReservation = new DeliveryReservation();
    reservation.tipo = deliveryType;
    reservation.id_tipo = deliveryId;
    reservation.tiporecogida = tiporecogida;
    return this.setDeliveryAxa(temp_id, reservation).pipe(
      concatMap(res => {
        return this.http.get<any>(`${environment.API_ENDPOINT}delivery/${temp_id}/${tiporecogida}/query`).pipe(
          map(result => {
            return new ScheduleDeliveries(result);
          })
        );
      })
    );


  }

  public setDeliveryAxa(temp_id: string, reservation: DeliveryReservation) {
    return this.http.post<any>(`${environment.API_ENDPOINT}delivery/${temp_id}/axaselect`, reservation).pipe();
  }

  getPriceHeaderAXA(id: string): Observable<number> {
    return this.http.get<number>(`${environment.API_ENDPOINT}delivery/${id}/axacost`).pipe(
      catchError(err => {
        return throwError(err);
      }),
    );
  }

  //20250602 axa final



  SilenceCleanBasket(isAxA: boolean, isSilenceCorrection: boolean) {
    return this.http.get<any>(
      `${environment.API_ENDPOINT}basket/${this.basketId}/${isAxA}/${isSilenceCorrection}/SilenceCleanBasket`,
      {}
    ).pipe(
      catchError(error => {        
        return throwError(error);
      })
    );
  }



}
